// Friendly modal shown when the AI service is overloaded (rate-limited or
// timing out). Better than a generic error toast — keeps users from bouncing
// during traffic spikes (e.g. when a viral reel drives a sudden flood).
import { CloudLightning } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface Props {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  onRetry?: () => void;
}

export const HighDemandDialog = ({ open, onOpenChange, onRetry }: Props) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-sm">
      <DialogHeader>
        <div className="mx-auto mb-2 flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-primary to-primary/60 text-primary-foreground">
          <CloudLightning className="h-7 w-7" />
        </div>
        <DialogTitle className="text-center">We're flooded right now ⚡</DialogTitle>
        <DialogDescription className="text-center">
          Tons of people are styling their photos at the same moment. Give it
          a minute and try again — your credits are safe.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter className="flex flex-col gap-2 sm:flex-col">
        {onRetry && (
          <Button onClick={() => { onOpenChange(false); onRetry(); }} size="lg" className="w-full">
            Try again
          </Button>
        )}
        <Button variant="ghost" onClick={() => onOpenChange(false)} className="w-full">
          Close
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
